import React from "react";
import "../../App.css";

const ListGroup = ({
  label,
  items,
  textProperty,
  valueProperty,
  direction,
  onItemSelect,
  selectedItem,
}) => {
  return (
    <div>
      {label && <label>{label}</label>}
      <div className="form-group">
        <ul
          className={
            direction === "horizontal"
              ? "list-group list-group-horizontal mx-auto"
              : "list-group mx-auto"
          }
        >
          {items.map((item) => (
            <li
              onClick={() => onItemSelect(item)}
              key={item[valueProperty]}
              className={
                item[valueProperty] === selectedItem[valueProperty]
                  ? "list-group-item listItem active"
                  : "list-group-item listItem"
              }
            >
              {item[textProperty]}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

ListGroup.defaultProps = {
  textProperty: "name",
  valueProperty: "id",
  direction: "horizontal",
};

export default ListGroup;
